import AuthService from "./authService";

const ComplaintFormService = {
    registerResponse: async (complaintFormUuid, data) => {
        try {
            let headers = {
                "Accept": "application/json",
                "Content-Type": "application/json"
            };

            if (localStorage.getItem("token")) {
                headers.Authorization = `Bearer ${AuthService.getToken()}`;
            }

            const request = await fetch(
                `${__myapp.env.API_URL}complaint-form/${complaintFormUuid}/response`,
                {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(data)
                }
            );

            const response = await request.json();

            if (!request.ok) {
                return {
                    success: false,
                    body: response
                }
            }
            else {
                return {
                    success: true,
                    body: response.data
                }
            }
        }
        catch (error) {
            return {
                error: error,
            };
        }
    },
    checkComplaint: async (data) => {
        try {
            let headers = {
                "Accept": "application/json",
                "Content-Type": "application/json"
            };

            const request = await fetch(
                `${__myapp.env.API_URL}complaint-form-answer`,
                {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(data)
                }
            );

            const response = await request.json();

            if (!request.ok) {
                return {
                    success: false,
                    body: response
                }
            }
            else {
                return {
                    success: true,
                    body: response.data
                }
            }
        }
        catch (error) {
            return {
                error: error,
            };
        }
    },
    createMessage: async (complaintFormAnswerUuid, message, files) => {
        try {
            let headers = {
                "Accept": "application/json",
                "Content-Type": "application/json"
            };

            if (AuthService.isAuthenticated()) {
                headers.Authorization = `Bearer ${AuthService.getToken()}`;
            };

            const request = await fetch(
                `${__myapp.env.API_URL}complaint-form-answer/${complaintFormAnswerUuid}/message`,
                {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify({ message: message, files: files })
                }
            );

            const response = await request.json();

            if (!request.ok) {
                return {
                    success: false,
                    body: response
                }
            }
            else {
                return {
                    success: true,
                    body: response.data
                }
            }
        }
        catch (error) {
            return {
                error: error,
            };
        }
    },
    getComplaintAnswer: async (complaintFormAnswerUuid) => {
        try {
            let headers = {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${AuthService.getToken()}`
            };

            const request = await fetch(`${__myapp.env.API_URL}complaint-form-answer/${complaintFormAnswerUuid}`, { headers: headers });

            const response = await request.json();

            if (!request.ok) {
                return {
                    success: false,
                    body: response
                }
            }
            else {
                return {
                    success: true,
                    body: response.data
                }
            }
        }
        catch (error) {
            return {
                error: error,
            };
        }
    },
    getUserListComplaintAnswers: async () => {
        try {
            let headers = {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${AuthService.getToken()}`
            };

            const request = await fetch(`${__myapp.env.API_URL}complaint-form-answer`, { headers: headers });

            const response = await request.json();

            if (!request.ok) {
                return {
                    success: false,
                    body: response
                }
            }
            else {
                return {
                    success: true,
                    body: response.data
                }
            }
        }
        catch (error) {
            return {
                error: error,
            };
        }
    }
}

export default ComplaintFormService;
